// DEPRECATED

export default {
  componentsConfig: [
    {
      componentName: 'BInputWrapper',
      uiSchemaMatcher: { uiType: 'BInputWrapper' },
      // eventName: 'changeInput',
      props: (propName, schema, uiSchema) => {
        // console.log('propName', propName);
        // console.log('schema', schema);
        // console.log('uiSchema', uiSchema);
        return {
          'full-width': true,
          class: 'sb2-bordered sb2-hoverable sb2-focusable',
          placeholder: schema.placeholder,
          validators: schema.validators,
          schema,
        };
      },
    },
    {
      componentName: 'SBTextareaWrapper',
      uiSchemaMatcher: { uiType: 'SBTextareaWrapper' },
      // eventName: 'changeInput',
      props: (propName, schema, uiSchema) => {
        return {
          'full-width': true,
          class: 'sb2-bordered sb2-hoverable sb2-focusable',
          placeholder: schema.placeholder,
          validators: schema.validators,
          schema,
        };
      },
    },
    {
      componentName: 'SBDropdownWrapper',
      uiSchemaMatcher: { uiType: 'SBDropdownWrapper' },
      // eventName: 'changeInput',
      props: (propName, schema, uiSchema) => {
        // console.log('DROPDOWN');
        // console.log(uiSchema);
        return {
          class: 'sb2-bordered sb2-hoverable sb2-focusable',
          placeholder: schema.placeholder,
          validators: schema.validators,
          required: schema.validators ? schema.validators.split('|').includes('required') : false,
          schema,
          // 'ui-schema': uiSchema,
        };
      },
    },
    {
      componentName: 'NMBRButtonsWrapper',
      uiSchemaMatcher: { uiType: 'NMBRButtonsWrapper' },
      props: (propName, schema, uiSchema) => {
        return {
          'full-width': true,
          class: 'sb2-bordered sb2-hoverable sb2-focusable',
          placeholder: schema.placeholder,
          validators: schema.validators,
          schema,
        };
      },
    },
    {
      componentName: 'DividerWrapper',
      // uiSchemaMatcher: { uiType: 'DividerWrapper' },
      matcher: { type: 'dividerFull' },
      props: (propName, schema, uiSchema) => {
        return {
          'full-width': true,
          schema,
        };
      },
    },
    {
      componentName: 'DividerWrapper',
      // uiSchemaMatcher: { uiType: 'DividerWrapper' },           // IMPORTANT: maybe uiSchema is not needed
      matcher: { type: 'divider' },
      props: (propName, schema, uiSchema) => {
        return {
          'full-width': false,
          schema,
        };
      },
    },
    {
      componentName: 'SkeletonWrapper',
      // uiSchemaMatcher: { uiType: 'DividerWrapper' },           // IMPORTANT: maybe uiSchema is not needed
      matcher: { type: 'skeleton' },
      props: (propName, schema, uiSchema) => {
        return {
          'full-width': false,
          schema,
        };
      },
    },
    {
      componentName: 'NMBRActionsWrapper',
      matcher: { type: 'action-buttons' },
      props: (propName, schema, uiSchema) => {
        return {
          class: 'sb2-bordered sb2-hoverable sb2-focusable',
          validators: schema.validators,
          schema,
        };
      },
    },
    {
      componentName: 'FileInputWrapper',
      matcher: { type: 'file-input-wrapper' },
      props: (propName, schema, uiSchema) => {
        return {
          class: 'sb2-bordered sb2-hoverable sb2-focusable',
          validators: schema.validators,
          schema,
        };
      },
    },
    {
      componentName: 'UrlInputWrapper',
      matcher: { type: 'url-input-wrapper' },
      props: (propName, schema, uiSchema) => {
        return {
          class: 'sb2-bordered sb2-hoverable sb2-focusable',
          validators: schema.validators,
          schema,
        };
      },
    },
  ],
};

// DEPRECATED